import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
import { CookieService } from 'ngx-cookie-service';
import { CurrentUserService } from './currentuser.service';
import { ICurrentUserModel } from '@models/auth/auth.model';

@Injectable({ providedIn: 'root' })
export class HttpHeaderService {
  constructor(
    private storageService: StorageService,
    private cookieService: CookieService,
    private currentuserService: CurrentUserService
  ) {}
  get(): HttpHeaders {
    const currentUser: ICurrentUserModel = this.currentuserService.get();
    if (currentUser?.jwtToken) {
      return new HttpHeaders({
        // 'Content-Type': 'application/json',
        authorization: `bearer ${currentUser?.jwtToken}`,
      });
    } else {
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
  }
}
